import React from 'react'
import { TaskState } from 'state/tasks'
import { TASK_TYPE_ENUM, EngagementType } from 'services/api/constants'
import { TaskSections } from '../../index'
import TaskSetUpEditor from '../TaskSetUpEditor'
import StepsEditor from './StepsEditor'
import TaskScheduleEditor from '../TaskScheduleEditor'
import PayoutEditor from '../PayoutEditor'

interface EditorProps {
    task: TaskState
    requiredFieldNames: { [key: string]: string[] }
    engagementTypes?: EngagementType[]
    selectedTaskSection: TaskSections
    showBrief?: boolean
}

const SocialMediaTaskEditor: React.FC<EditorProps> = ({
    task,
    requiredFieldNames,
    engagementTypes,
    selectedTaskSection,
    showBrief,
}) => {
    const taskTypeNameWithoutVersion = task.type.split(/(_v\d+)/)[0] as TASK_TYPE_ENUM

    const getTaskEditor = (): React.ReactElement => {
        switch (selectedTaskSection) {
            case TaskSections.SETUP:
                return <TaskSetUpEditor type={taskTypeNameWithoutVersion} taskUuid={task.uuid} />
            case TaskSections.STEPS:
                return (
                    <StepsEditor
                        type={taskTypeNameWithoutVersion}
                        requiredFieldNames={requiredFieldNames}
                        task={task}
                        engagementTypes={engagementTypes}
                        showBrief={showBrief}
                    />
                )
            case TaskSections.SCHEDULE:
                return <TaskScheduleEditor taskType={taskTypeNameWithoutVersion} taskUuid={task.uuid} />
            case TaskSections.PAYOUT:
                return <PayoutEditor taskType={task.type} taskUuid={task.uuid} />
            default:
                return <></>
        }
    }
    return <>{getTaskEditor()}</>
}
export default SocialMediaTaskEditor
